import { getImage } from '@utils/imageHelper';
import styled from '@emotion/styled';
import { Fonts, Spacings, mediaQuery } from '@styles/index';
import boxShadowGenerator from '@utils/boxShadowGenerator';
import CheckCircleFilled from '@icon/CheckCircleFilled';
import { keyframes } from '@emotion/react';
import P1 from '@base/P1/P1';
import H3 from '@base/H3/H3';

const EnquiryThankyouSection = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 464px;
  height: 518px;
  margin-top: ${Spacings.SPACING_10B};
  margin-bottom: ${Spacings.SPACING_10B};
  padding-top: ${Spacings.SPACING_10B};
  padding-bottom: ${Spacings.SPACING_15B};
  background: var(--color-i-white);
  box-shadow: ${boxShadowGenerator()};
  border-radius: ${Spacings.SPACING_2B};
  ${mediaQuery.uptoMobile} {
    width: 100%;
    min-width: 100%;
    margin: 0px;
  }
`;

const ThankyouWrapper = styled.div`
  width: 100%;
`;

const ThankyouHeader = styled(H3)`
  text-align: center;
  margin-top: -${Spacings.SPACING_8B};
  position: relative;
  color: var(--color-i-green);
  ${mediaQuery.uptoMobile} {
    font-size: ${Fonts.H4};
  }
`;

const ThankyouSubHeader = styled(P1)`
  margin: auto;
  max-width: 100%;
  text-align: center;
  font-size: ${Spacings.SPACING_14};
  font-weight: ${Fonts.LIGHT};
  line-height: 20px;
  color: var(--color-i-black);
  margin-top: ${Spacings.SPACING_2B};
`;

const ImageContainer = styled.div`
  position: relative;
  text-align: center;
`;

const StyledImg = styled.img`
  user-drag: none;
  user-select: none;
`;

const Confetti = styled(StyledImg)`
  width: 360px;
  height: 160px;
  object-fit: cover;
  object-position: center 35%;
  ${mediaQuery.uptoMobile} {
    width: 100%;
    height: 44.44vh;
    max-width: 360px;
    max-height: 160px;
  }
`;

const ShadowPulse = keyframes`
  0% { box-shadow: ${boxShadowGenerator({
    yOffset: '0',
    blur: '0',
    color: 'rgba(8, 189, 128, 0.4)'
  })}; }
  70% { box-shadow: ${boxShadowGenerator({
    yOffset: '0',
    blur: '0',
    spread: '10px',
    color: 'rgba(8, 189, 128, 0)'
  })}; }
  100% {
    box-shadow: none;
  }
`;

const PulsatingGreenTick = styled(CheckCircleFilled)`
  animation: ${ShadowPulse} 2s infinite;
  border-radius: 50%;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
`;

const EnquiryThankyou = () => {
  return (
    <EnquiryThankyouSection>
      <ThankyouWrapper>
        <ImageContainer>
          <Confetti
            alt="confetti"
            src={getImage('bundles/offlineConfetti.gif')}
          />
          <PulsatingGreenTick
            size="65px"
            color="var(--color-i-green)"
            viewBox="4 4 16 16"
          />
        </ImageContainer>
        <ThankyouHeader>Thank you</ThankyouHeader>
        <ThankyouSubHeader>
          Your details have been captured,
          <br />
          We will reach out to you soon.
        </ThankyouSubHeader>
      </ThankyouWrapper>
    </EnquiryThankyouSection>
  );
};

export default EnquiryThankyou;
